import React from 'react'

import { Link } from 'core'

import css from './style.scss'

/**
 * The repeating body shared by the Member Resources and What's New blocks:
 * a heading, optional rich text, and an optional link, ruled off from the next.
 */
const ResourceSectionList = ({ sections }) => (
  <ul className={css.sectionList}>
    {sections.map((section, index) => (
      <li key={index} className={css.section}>
        {section.header && <h3 className={css.sectionHeader}>{section.header}</h3>}
        {section.text && (
          <div className={css.sectionText} dangerouslySetInnerHTML={{ __html: section.text }} />
        )}
        {section.link_url && (
          <Link to={section.link_url}>
            <span className={css.sectionLink}>{section.link_label || 'Learn more'}</span>
          </Link>
        )}
      </li>
    ))}
  </ul>
)

ResourceSectionList.propTypes = {
  sections: React.PropTypes.arrayOf(React.PropTypes.shape({
    header: React.PropTypes.string,
    text: React.PropTypes.string,
    link_url: React.PropTypes.string,
    link_label: React.PropTypes.string
  })).isRequired
}

export default ResourceSectionList
